
import Grid from '@material-ui/core/Grid';
import Dialog from '@base/Dialog';
import Chip from '@material-ui/core/Chip'

export const HistoricoCaixasDialog = (props) => {
  const open = props.aberto ?? false;
  const objetoPostal = props.objetoPostal;

  const converteDataBR = (dataStr) => {
    if (!dataStr) return 0;

    const [data, horaString] = dataStr.split(' ');
    const [dia, mes, ano] = data.split('/');

    let [hora, minuto, segundo] = [0, 0, 0];
    if (horaString) {
      [hora, minuto, segundo] = horaString.split(':');
    }

    return new Date(ano, mes - 1, dia, hora, minuto, segundo).getTime();
  };

  const list = [...(objetoPostal?.objetoPostalHistoricoCaixas || [])].sort((a, b) => {
    return converteDataBR(b.dataAlteracao) - converteDataBR(a.dataAlteracao);
  });

  function renderizaCaixaAtiva(caixa) {

    return <>
      {caixa !== null && caixa !== '' ? caixa : "X"}
      {caixa !== null && objetoPostal.caixaCodigo === caixa ?
        <Chip size="small" label={"Caixa Atual"} style={{ backgroundColor: '#5fb36f', color: 'white', fontSize: 11, marginLeft: '5px' }}></Chip>
        : ""}
    </>
  }

  return (
    <Dialog
      maxWidth="md"
      fullWidth={true}
      closeDialog={props.aoFechar}
      openDialog={open}
      title="Histórico de Caixas do Objeto Postal"
    >
      <Grid container>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse'
          }}
        >
          <thead>
            <tr>
              <th style={styles.th}>Código Caixa</th>
              <th style={styles.th}>Data da Alteração</th>
              <th style={styles.th}>Responsável</th>
            </tr>
          </thead>

          <tbody>
            {list.length > 0 ? (
              list.map((item, index) => (
                <tr key={index}>
                  <td style={styles.td}>
                    {renderizaCaixaAtiva(item.caixaCodigo)}
                  </td>

                  <td style={styles.td}>
                    {item.dataAlteracao}
                  </td>

                  <td style={styles.td}>
                    {item.responsavelAlteracao}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td style={styles.td} colSpan={4}>
                  Nenhum registro encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Grid>
    </Dialog>
  );
};

const styles = {
  th: {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold'
  },
  td: {
    border: '1px solid #ddd',
    padding: '8px'
  }
};

export default HistoricoCaixasDialog;
